
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinvimannagar() {



    const cardData =
    {
        keyword: 'Cab Service in Viman Nagar',
        heading: 'Platinum24 Cabs: Cab Service in Viman Nagar',
        headingDescription: ' Platinum24 Cabs offers reliable Cab Service in Viman Nagar, catering to local city rides, airport transfers, corporate travel, and outstation journeys. Our fleet includes hatchbacks, sedans, SUVs, and luxury cars, all maintained to deliver maximum comfort and safety. With professional chauffeurs, timely pickups, and transparent fares, we ensure smooth and stress-free travel for residents, students, and business professionals in Viman Nagar. Whether you need a quick ride to Pune Airport, a family outing, or a long-distance trip, Platinum24 Cabs provides 24/7 availability, affordability, and dependable service in Viman Nagar.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. Once the political seat of the Maratha Empire, it showcases grand gates, fountains, and gardens. Although partially destroyed by fire in 1828, its ruins still narrate tales of Bajirao and Mastani. The evening light-and-sound show brings history alive. Tourists love exploring its majestic corridors and courtyards. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a majestic monument with Indo-Italian architecture. It gained prominence during the freedom struggle as Mahatma Gandhi and Kasturba Gandhi were imprisoned here during the Quit India Movement. The palace now houses a museum with Gandhi’s personal items and photos. Surrounded by sprawling gardens, it offers peace and reflection. It is also a memorial to Kasturba Gandhi. Aga Khan Palace is Pune’s inspirational historic site."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, 25 km from Pune, is famous for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. The hill fort offers trekking trails with scenic views of the Sahyadris. Visitors explore bastions, temples, and memorials that echo Maratha valor. Monsoon makes it lush with mist and waterfalls. Local villagers serve traditional pithla-bhakri at the top. Sinhagad is Pune’s blend of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The magnificent idol is adorned with gold and precious ornaments. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also renowned for charitable and cultural activities. Devotees visit throughout the year for blessings. Dagdusheth Temple is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved in the 8th century, Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. The temple features huge stone pillars, a sanctum, and a Nandi mandapa. Located in the city center, it provides peace and spirituality amidst urban life. Its ancient carvings reflect early Indian craftsmanship. Evening prayers add to its mystical charm. Pataleshwar is Pune’s hidden spiritual heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include sculptures, ornaments, musical instruments, and daily-life antiques. The recreated Mastani Mahal is the museum’s highlight. Students, historians, and tourists find it educational and fascinating. It preserves centuries of Indian art and traditions. The museum is Pune’s cultural treasure trove."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop Parvati Temple is dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. The climb of 103 steps is both devotional and adventurous. Smaller shrines and museums surround the main temple. Sunrise and sunset views are mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for spirituality and wellness. Spread across lush gardens, it attracts visitors from all over the world. The ashram offers meditation, yoga, and personal growth workshops. Japanese Zen gardens and tranquil halls enhance the experience. It is ideal for peace, rejuvenation, and self-discovery. Osho Ashram is Pune’s international wellness destination."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, stone bridges, and manicured lawns create a serene environment. Families enjoy peaceful strolls, picnics, and photography here. The garden represents Indo-Japanese friendship. Seasonal flowers make it colorful year-round. Pu La Deshpande Garden is Pune’s green oasis of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city and offers picturesque views of hills and flowing waters. During monsoon, the overflowing dam is a spectacular sight. Vendors selling roasted corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],



   "services": [
    {
      "name": "Cab Service Viman Nagar Pune",
      "description": "Get dependable cab services in Viman Nagar Pune for all your travel needs, whether local, airport, or outstation. Our cab fleet is well-maintained, sanitized regularly, and comes with experienced drivers. Enjoy comfortable seating, AC, and GPS navigation. Whether it's for shopping, dining out, or commuting to work, we provide timely and affordable service right from the heart of Viman Nagar."
    },
    {
      "name": "Viman Nagar Taxi Service",
      "description": "Viman Nagar taxi services offer round-the-clock transportation support for residents, students, and visitors. Choose from hatchbacks, sedans, SUVs, or premium vehicles depending on your preference. Whether you're heading to the airport, railway station, or across the city, our reliable taxi service ensures you reach safely and on time."
    },
    {
      "name": "Taxi Booking in Viman Nagar Pune",
      "description": "Book a taxi in Viman Nagar Pune instantly via our app, website, or helpline. Our platform provides real-time availability, live tracking, secure digital payments, and booking flexibility. Select the vehicle type and trip plan (one-way, return, hourly) for a seamless travel experience in and around Pune city."
    },
    {
      "name": "Local Cab Viman Nagar",
      "description": "Our local cab service in Viman Nagar is perfect for quick errands, shopping trips, or local appointments. Affordable, fast, and dependable — our cabs operate within city limits with professional drivers and clean cars. Ideal for students, families, and working professionals needing reliable point-to-point travel."
    },
    {
      "name": "Viman Nagar Cab Rental",
      "description": "Rent a cab in Viman Nagar for hourly, half-day, or full-day packages. Our cab rental service includes chauffeur-driven vehicles with transparent pricing and flexible trip durations. Suitable for sightseeing, personal use, or attending city events without worrying about parking or traffic."
    },
    {
      "name": "Affordable Taxi Viman Nagar",
      "description": "Looking for a low-cost taxi in Viman Nagar? We offer affordable rides without compromising safety or comfort. With fixed fares, no hidden charges, and promotional discounts, our taxi service is budget-friendly for daily commuters, students, and local travelers."
    },
    {
      "name": "Viman Nagar Cab Hire",
      "description": "Hire a cab in Viman Nagar for personal or professional travel requirements. Choose from economy to luxury options based on your budget. Our services are ideal for weddings, events, or formal meetings. All cars are well-maintained and come with courteous, uniformed drivers."
    },
    {
      "name": "Viman Nagar Taxi Booking Online",
      "description": "Book your Viman Nagar taxi online in just a few clicks. Our digital platform allows you to choose car type, schedule ride timings, and make secure online payments. Get booking confirmation instantly along with live driver tracking and 24x7 customer assistance."
    },
    {
      "name": "Reliable Cab Service Viman Nagar",
      "description": "Our reliable cab service in Viman Nagar is trusted by thousands of customers for punctuality, driver professionalism, and clean vehicles. All cabs are verified and safety-checked before each trip. We focus on comfort, convenience, and customer satisfaction for local and long-distance rides."
    },
    {
      "name": "Viman Nagar Local Taxi",
      "description": "Viman Nagar local taxi service caters to daily transport needs such as shopping, school pickups, doctor visits, and quick office commutes. Available instantly or scheduled as per your timing, our taxis are economical and driven by experienced locals familiar with the area."
    },
    {
      "name": "Viman Nagar Airport Taxi",
      "description": "Book a direct airport taxi from Viman Nagar to Pune Airport or from the airport to Viman Nagar. Our drivers are punctual, assist with luggage, and know the fastest routes to avoid delays. Great for early-morning or late-night flights with on-time guarantee and fixed pricing."
    },
    {
      "name": "Viman Nagar Outstation Taxi",
      "description": "Need to travel outside Pune from Viman Nagar? Our outstation taxi service provides safe, comfortable, and affordable trips to nearby cities like Mumbai, Lonavala, Nashik, or Goa. Choose one-way, round trip, or multi-day plans with a range of car models to suit your group size."
    },
    {
      "name": "Viman Nagar Corporate Cab Service",
      "description": "We offer specialized corporate cab services in Viman Nagar for office pickups, employee transportation, and business travel. Choose from daily, weekly, or monthly packages with invoicing support, professional chauffeurs, and executive-class vehicles."
    },
    {
      "name": "Viman Nagar Night Taxi Service",
      "description": "Late-night travel made safe and easy with our night taxi service in Viman Nagar. Available after 9 PM until early morning, our night taxis include extra safety checks, emergency support, and night-trained drivers to ensure smooth travel during off-hours."
    },
    {
      "name": "Viman Nagar Cab for Events",
      "description": "Hosting or attending an event in or near Viman Nagar? Book event-specific cabs for hassle-free transport to weddings, conferences, concerts, or private parties. Choose multiple pickup points, time slots, and vehicle types for convenient guest travel."
    }
  ],
  "tableData": [
    ["Cab Service Viman Nagar Pune", "Viman Nagar Taxi Service"],
    ["Taxi Booking in Viman Nagar Pune", "Local Cab Viman Nagar"],
    ["Viman Nagar Cab Rental", "Affordable Taxi Viman Nagar"],
    ["Viman Nagar Cab Hire", "Viman Nagar Taxi Booking Online"],
    ["Reliable Cab Service Viman Nagar", "Viman Nagar Local Taxi"],
    ["Viman Nagar Airport Taxi", "Viman Nagar Outstation Taxi"],
    ["Viman Nagar Corporate Cab Service", "Viman Nagar Night Taxi Service"],
    ["Viman Nagar Cab for Events", "—"]
  ],


        "whychoose": [
    {
      "WhyChooseheading": "Trusted Cab Service in Viman Nagar, Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers reliable and quick cab services in Viman Nagar for daily travel and special trips."
    },
    {
      "WhyChooseheading": "Fast Pickups with Nearby Drivers Always Available",
      "WhyChoosedescription": "Get picked up in minutes with our GPS-enabled cabs stationed near Viman Nagar."
    },
    {
      "WhyChooseheading": "Affordable Local and Outstation Cab Options",
      "WhyChoosedescription": "Choose from pocket-friendly rates for short local rides or longer intercity travel."
    },
    {
      "WhyChooseheading": "Clean and Well-Maintained Vehicles for Every Ride",
      "WhyChoosedescription": "Enjoy hygienic, air-conditioned, and comfortable cabs for every occasion."
    },
    {
      "WhyChooseheading": "Verified Drivers for a Safe Travel Experience",
      "WhyChoosedescription": "All drivers are background-verified and professionally trained to ensure your safety and comfort."
    },
    {
      "WhyChooseheading": "24/7 Cab Availability in Viman Nagar",
      "WhyChoosedescription": "Book a cab anytime—day or night—within minutes using our seamless booking process."
    },
    {
      "WhyChooseheading": "Flexible Booking for One-Way, Round Trip, or Hourly Rentals",
      "WhyChoosedescription": "Choose a ride plan that suits your personal or business travel needs."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Extra Charges",
      "WhyChoosedescription": "Get all-inclusive fares with no hidden fees—fuel, tolls, and driver charges are covered."
    }
  ]

























    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services in Viman Nagar?',
        answer: 'Yes, Platinum24 Cabs offers reliable and convenient cab services within Viman Nagar for local travel.',
    },
    {
        question: 'How can I book a cab service in Viman Nagar with Platinum24 Cabs?',
        answer: 'You can book a cab in Viman Nagar easily through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for cab service in Viman Nagar?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars to suit your travel needs.',
    },
    {
        question: 'Are the drivers experienced for local travel within Viman Nagar?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about the Viman Nagar area.',
    },
    {
        question: 'Can I book a cab for hourly or daily use in Viman Nagar?',
        answer: 'Absolutely! We provide flexible hourly and daily cab rental packages tailored to your schedule.',
    },
    {
        question: 'What is included in the fare for cab services in Viman Nagar?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations within Viman Nagar?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points within Viman Nagar for maximum convenience.',
    },
    {
        question: 'Are safety measures followed for cab services in Viman Nagar?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols to ensure passenger safety.',
    },
    {
        question: 'Is corporate cab service available in Viman Nagar?',
        answer: 'Yes, we offer customized corporate cab services in Viman Nagar with priority support and flexible billing.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Arjun Joshi',
        feedback: 'The cab service in Viman Nagar by Platinum24 Cabs was prompt and comfortable. Highly recommended!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Patil',
        feedback: 'Booking a cab in Viman Nagar was easy and hassle-free. The driver was professional and courteous.',
        rating: 5,
    },
];








































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const cabServiceVimanNagarSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Viman Nagar",
  "image": "https://www.platinum24cab.com/assets/images/viman-nagar-cab-service.jpg",
  "description": "Book reliable cab service in Viman Nagar, Pune with Platinum24 Cabs. Affordable local, airport, outstation, and corporate taxi options with verified drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "300",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/cab-service-viman-nagar"
  }
};






    return (
        <div>
<Helmet>
  <title>Cab Service in Viman Nagar | Local & Airport Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book reliable cab service in Viman Nagar, Pune with Platinum24 Cabs. Affordable local, airport, outstation, and corporate taxi options with verified drivers."
  />
  <meta
    name="keywords"
    content="Cab Service Viman Nagar Pune, Viman Nagar Taxi Service, Taxi Booking in Viman Nagar Pune, Local Cab Viman Nagar, Viman Nagar Cab Rental, Affordable Taxi Viman Nagar, Viman Nagar Cab Hire, Viman Nagar Taxi Booking Online, Reliable Cab Service Viman Nagar, Viman Nagar Local Taxi, Viman Nagar Airport Taxi, Viman Nagar Outstation Taxi, Viman Nagar Corporate Cab Service, Viman Nagar Night Taxi Service, Viman Nagar Cab for Events"
  />
  <script type="application/ld+json">
    {JSON.stringify(cabServiceVimanNagarSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/28.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinvimannagar;